
import React from 'react'
import Banner from '../home/banner/banner'
import { Tabs, Pagination } from 'antd'
import Footer from '../footer/footer'
import RightBtn from '../rightBtn/rightBtn';
const TabPane = Tabs.TabPane;

require('./newscenter.scss')

import { Get, wrapResponse } from './../../requst'

export default class NewsCenter extends React.Component {
    static async getInitialProps(ctx) {
        const [data, cateGoryAndTag, newsCenter, newsDetail] = await Promise.all([
            wrapResponse(Get({ url: 'news/banner' })),
            wrapResponse(Get({ url: 'news/cateGoryAndTag' })),
            // wrapResponse(Get({ url: 'news/newsCenter', data: { cate_id: 1, page: 1, size: 10 } })),
            wrapResponse(Get({ url: 'news/allNews?page=1&size=1000000' })),
            wrapResponse(Get({ url: 'news/newsDetail' })),
        ])

        const footerProps = await Footer.getInitialProps()
        cateGoryAndTag.category.unshift({ id: 'all', title: '全部' })
        return { data, cateGoryAndTag, newsCenter, newsDetail, footerProps }
    }

    constructor(props, context) {
        super(props, context);
        this.callback = this.callback.bind(this);
        this.TAGcallback = this.TAGcallback.bind(this);
        this.state = {
            cate_id: 'all',
            cate_title: '全部',
            newsCenter: this.props.newsCenter
        }

    }

    renderTab() {
        // console.log(this.state.cateGoryAndTag.category)
        return this.props.cateGoryAndTag.category.map((item, index) => (
            <TabPane tab={item.title} key={item.id}>
            </TabPane>
        ))
    }
    renderTag() {
        return this.props.cateGoryAndTag.tags.map((item, index) => (
            <TabPane tab={item.title} key={item.title}>
            </TabPane>
        ))
    }
    callback({ key, page = 1 }) {
        if (key === 'all') {
            // console.log(key);
            // let keyNum = key - 1;
            this.setState({ cate_id: key })
            // console.log('this.state.cateGoryAndTag.category[key].title',this.state.cateGoryAndTag.category[keyNum].title)
            this.setState({ cate_title: this.props.cateGoryAndTag.category[0].title })
            this.Get({ url: 'news/allNews', data: { cate_id: key, page: page, size: 10 } }).then((res) => {

                this.setState({ newsCenter: res.data.data })
            })
        } else {
            // console.log(key);
            let keyNum = key - 1;
            this.setState({ cate_id: key })
            // console.log('this.state.cateGoryAndTag.category[key].title',this.state.cateGoryAndTag.category[keyNum].title)
            this.setState({ cate_title: this.props.cateGoryAndTag.category[keyNum].title })
            this.Get({ url: 'news/newsCenter', data: { cate_id: key, page: page, size: 10 } }).then((res) => {

                this.setState({ newsCenter: res.data.data })
            })
        }
    }
    TAGcallback(tag) {
        // console.log('key',tag)
        this.Get({ url: 'news/newsCenter', data: { cate_id: this.props.cate_id, tag_title: tag, page: 1, size: 10 } }).then((res) => {
            // console.log(res)
            this.setState({ newsCenter: res.data.data })
        })
    }

    newsCenter() {
        return this.state.newsCenter.newsDatas.map((item, index) => (
            <a href={`/details/${item.id}`} style={{ cursor: 'pointer', display: index < 10 ? 'block' : 'none' }} key={index} >
                <div className="Title">
                    <p>{item.created_at.substring(8, 11)}</p>
                    <p>{item.created_at.substring(0, 7)}</p>
                </div>
                <div className="Image">
                    <img src={item.thumb} alt="" />
                </div>
                <div className="Text">
                    <p>{item.title}</p>
                    <p>{item.desc}</p>
                    <p> <img src={require('../../assets/common/images/biaoqian@2x.png')} alt="" /> {item.tags}</p>
                </div>
                <div><a style={{ display: "none" }} href={`/details/${item.id}`}>{item.title}</a></div>
            </a>
        ))
    }
    render() {
        console.log(11, this.state.newsCenter)
        // let tabKey= this.props.location.data?this.props.location.data.key.toString():'1'
        let tabKey = 'all'
        return (
            <div>
                <div style={{ width: '100%', height: '630px', display: 'flex', justifyContent: 'center' }}>
                    <img src={this.props.data ? this.props.data[0].photos : null} style={{ height: '100%' }} alt="" />
                </div>
                <div className="Information">
                    <div className="ContentBox">
                        {this.props.cateGoryAndTag ? <Tabs defaultActiveKey={tabKey} onChange={(key) => this.callback({ key })}>
                            {this.renderTab()}
                        </Tabs> : null}
                        <div className="AAA">
                            {this.props.cateGoryAndTag ? <Tabs defaultActiveKey="0" onChange={this.TAGcallback}>
                                {this.renderTag()}
                            </Tabs> : null}
                        </div>
                        <div className="NewsContent">
                            <ul className="NewsBox">

                                {this.state.newsCenter ? this.newsCenter() : null}
                            </ul>
                        </div>
                        <div className="Pagination">
                            <div className="fr">
                                <Pagination
                                    key={this.state.cate_id}
                                    defaultCurrent={1}
                                    total={this.state.newsCenter ? this.state.newsCenter.newsTotal : 0}
                                    onChange={(current) => {
                                        this.callback({ key: this.state.cate_id, page: current })
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Footer {...this.props.footerProps} />
                <RightBtn props={this.props} />
            </div>
        )
    }
}